<template>
  <div class="registered-users" v-if="dataLoaded">

    <div class="top">
      <chart-item class='chart-summary' :data="report" :isLink="false" :colorOverride="'#2E96D6'" />
      <div class="chart-actions">
        <div class="filter" v-if="false">
          <rp-dropdown
            v-model="dateSelected"
            :data-model="dates"
            disable-search
            placeholder="Select year"
            tempIdentifier="Time"
            iconText="Show data from:"
            @input="getReports"
          />
        </div>
      </div>
    </div>

    <div class="chart-main">
      <LineChartGenerator
        id="line-satisfaction"
        :chart-data="lineChartData"
        :chart-options="lineChartOptions"
        :height="300"
      />
    </div>

  </div>
</template>

<script>
  import ChartItem from '../ChartItem_v2'
  import SelectField from 'raypro_ui/src/components/ui/inputs/StyledSelect'
  import RpSprite from 'raypro_ui/src/components/ui/Sprite'
  import Dropdown from 'raypro_ui/src/components/ui/inputs/dropdown/Dropdown'
  import breakdown from '../../../../mixins/breakdown'
  // Chart.js
  import {Bar, Line as LineChartGenerator} from 'vue-chartjs/legacy'
  import {Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, LineElement, PointElement} from 'chart.js'
  ChartJS.register(Title, Tooltip, Legend, BarElement, LineElement, CategoryScale, LinearScale, PointElement)

  export default {
    mixins: [breakdown],

    components: {
      Bar,
      LineChartGenerator,
      ChartItem,
      RpSprite, 
      SelectField, 
      'rp-dropdown': Dropdown,
    },

    data() {
      return {
        report: {report_datas: {data: {}}},
        subReports: [
          {report: null, filter: '', color: '#DF5B96'},
          {report: null, filter: '', color: '#F09639'},
          {report: null, filter: '', color: '#F2C94C'},
        ],
        lineChartData: {
          datasets: [
            {label: 'Surgeons', borderColor:'#2E96D6', backgroundColor: '#2E96D6', data: []},
            {label: 'Nurses', borderColor:'#DF5B96', backgroundColor: '#DF5B96', data: []},
            {label: 'Patients', borderColor:'#F2C94C', backgroundColor: '#F2C94C', data: []},
            {label: 'Rayner Admin', borderColor:'#F09639', backgroundColor: '#F09639', data: []},
            {label: 'Regular Admin', borderColor:'#0A9D00', backgroundColor: '#0A9D00', data: []},
          ]
        },
        lineChartOptions: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            datalabels: {
              display: false,
            },
          },
          scales: {
            x: {
              title: {
                text: 'Month',
                display: true,
              },
              grid: {
                display: false,
              },
            },
            y: {
              min: 0,
              title: {
                display: true,
                text: 'Registered Users',
              },
              ticks: {
                precision: 1,
              },
            },
          },
        },
      }
    },

    methods: {
      async getReports() {
        this.report = await this.getReportByIdPromise(this.filterParams)
        this.lineChartData.datasets[0].data = this.getTimesForReport(this.report.times.surgeons)
        this.lineChartData.datasets[1].data = this.getTimesForReport(this.report.times.nurses)
        this.lineChartData.datasets[2].data = this.getTimesForReport(this.report.times.patients)
        this.lineChartData.datasets[3].data = this.getTimesForReport(this.report.times.rayner_admin)
        this.lineChartData.datasets[4].data = this.getTimesForReport(this.report.times.regular_admin)
        this.dataLoaded = true
      },

      getTimesForReport(data) {
        return data.map((item) => {
          return {
            'x': item.mon,
            'y': item.count
          }
        })
      },
    }
  }
</script>

<style lang="sass">
  @import 'raypro_ui/src/styles/base/_variables.sass'
  @import 'raypro_ui/src/styles/helpers/_mixins.sass'

  .registered-users
    display: flex
    flex-direction: column
    width: 100%
    padding: 10px
    margin-right: -30px
    box-shadow: $color-shadow
    background-color: transparent //$color-panel-bg

    .chart-main
      width: 100%
      border-radius: 20px
      background-color: $color-panel-bg

    .top
      display: flex
      flex-direction: column
      justify-content: flex-start
      width: 100%
      
      @include media($media-small)
        flex-direction: row

      .chart-summary
        width: 220px

      .chart-actions
        display: flex
        flex-direction: row
        align-items: center
        align-self: flex-end
        margin-left: auto
        margin-bottom: -28px
        //justify-content: center

        @include media($media-small)
          align-items: center

        .chart-dropdown
          width: 120px
          display: none

        .filter
          display: none

        .action-icons
          display: flex
          margin: 0 10px

          .sprite
            cursor: pointer
            width: 20px
            height: 20px
            margin: 0 3px
            fill: $color-side-nav

            @include media($media-small)
              margin: 0 3px

            svg
              fill: $color-panel-bg
              background-color: pink

          .custom-tooltip
            @include rp-tooltip(attr(data-tooltip))

          .custom-tooltip-download
            @include rp-tooltip(attr(data-tooltip))
            &::before
              width: auto

</style>



// WEBPACK FOOTER //
// src/components/pages/Dashboard/Breakdowns/RegisteredUsers_v2.vue